<template>
  <v-card height="100%"
          v-loading="isLoading">
    <v-card-title>
      <v-container class="panel">
        <v-layout row
                  wrap>
          <v-flex xs12>
            <v-layout column
                      class="panel-heading">
              <v-flex d-flex>
                <h2 class="panel-title">
                  <b>
                    <span v-html="$t('private_dash_table_availabilities_title')"></span>
                  </b>
                  <v-menu offset-y
                          class="right mr-2">
                    <v-icon color="primary"
                            slot="activator">mdi-dots-vertical</v-icon>
                    <v-list>
                      <v-list-tile @click="generalView = true">
                        <v-list-tile-title>{{$t('view_general_graph')}}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="generalView = false">
                        <v-list-tile-title>{{$t('view_detailed_graph')}}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <router-link :to=" { name: 'ParkingAvailability', params: { id: parkingId } }">
                    <v-icon color="primary"
                            class="right">visibility</v-icon>
                  </router-link>

                  <router-link :to=" { name: 'ParkingAvailability', params: { id: parkingId, isAvailabilityDialogVisible:true } }">
                    <v-icon color="primary"
                            class="right mr-1">edit</v-icon>
                  </router-link>
                </h2>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <span v-html="$t('private_dash_table_availabilities_title')"
                  v-if="isEmpty"></span>
            <div ref="chart"
                 v-else>
              <chart v-for="data in graphs"
                     :key="data.id"
                     :datasets="data.datasets"
                     :bar-options="data.barOptions"
                     :height="chartHeight"></chart>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import FromDateSelector from '@/components/commons/FromToDateSelector.vue';
import availabilityService from '@/services/availabilityService';
import Chart from '@/components/commons/charts/Chart.vue';
import { chartsHelpers } from '@/components/commons/charts/chartsHelpers';
import moment from 'moment';
import _ from 'lodash';
import keys from '@/store/keys';
import store from '@/store';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'availability-graph-box',
  components: {
    [FromDateSelector.name]: FromDateSelector,
    [Chart.name]: Chart
  },
  watch: {
    generalView: function(value) {
      this.updateAvailabilities(this.dates);
    }
  },
  props: ['parkingId'],
  data() {
    return {
      generalView: true,
      dates: [
        moment()
          .startOf('month')
          .toDate(),
        moment()
          .endOf('month')
          .toDate()
      ],
      graphs: [],
      isEmpty: false,
      plotUnit: 'day',
      parking: [],
      chartHeight: 600,
      isLoading: false
    };
  },
  created() {
    this.initializeGraph();
    this.parking = _.find(store.state.parkingList, itParking => {
      return itParking.id === this.parkingId;
    });
    EventBus.$on(keys.eventOnLanguageChanged, this.updateAvailabilities);
    EventBus.$on(keys.eventOnScreenSizeChanged, this.refreshGraph);

    let displaySize = chartsHelpers.getDisplaySize(this);

    if (displaySize === 'xs') {
      this.chartHeight = 600;
    } else {
      this.chartHeight = 250;
    }
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateAvailabilities);
    EventBus.$off(keys.eventOnScreenSizeChanged, this.refreshGraph);
  },
  methods: {
    initializeGraph() {
      this.graphs = [
        {
          datasets: {
            labels: this.dates,
            datasets: []
          },
          barOptions: chartsHelpers.getBarOptions(this),
          id: _.uniqueId()
        }
      ];
    },
    async refreshGraph(params) {
      this.initializeGraph();
      if (params.to === 'xs') {
        this.chartHeight = 600;
      } else {
        this.chartHeight = 250;
      }
      if (typeof this.$refs.chart === 'undefined') {
        return;
      }
      this.$refs.chart.getElementsByTagName('canvas')[0].style.width = 0;
      await this.updateAvailabilities(this.dates);
    },
    async updateAvailabilities(dates) {
      this.isLoading = true;
      if (typeof dates === 'undefined') {
        if (this.dates.length === 0) {
          return;
        }
      } else {
        this.dates = _.clone(dates);
      }

      let params = {
        parking: this.parkingId,
        start: moment(this.dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(this.dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        isSummary: true,
        withReservations: true
      };

      await availabilityService.list(params, this.availabilitySuccessCallback, this.availabilityErrorCallback);
    },
    availabilitySuccessCallback(data) {
      this.isLoading = false;
      if (typeof data.chartData === 'undefined' || data.chartData.length <= 0) {
        EventBus.$emit(keys.eventOnAvailabilityGraphDone, { done: true });
        this.isEmpty = true;
        return;
      }
      this.graphs = [];
      this.isEmpty = false;

      this.plotUnit = chartsHelpers.getPlotUnit(this.dates[0], this.dates[1]);

      let barOptions = chartsHelpers.getAvailabilityParkingHomeBarOptions(this, data);

      let fillChartDataResults = chartsHelpers.fillChartData(data.chartSettings, data.chartData, this.dates[0], this.dates[1], false, this.generalView);

      let date = fillChartDataResults.date;
      let dataSetsArray = fillChartDataResults.dataSetsArray;

      let datasets = {
        labels: date,
        datasets: dataSetsArray
      };

      this.graphs.push({
        datasets: datasets,
        barOptions: barOptions,
        id: _.uniqueId()
      });

      EventBus.$emit(keys.eventOnAvailabilityGraphDone, { done: true });
    },
    availabilityErrorCallback(data) {}
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/commons/AvailabilityGraphBox.vue